<template>
<v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs9>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>
              <span>Preguntas frecuentes</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small depressed  color="primary" to="/login">
              <v-icon>arrow_back</v-icon>
              &nbsp;
              Volver
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <faqs></faqs>
          </v-card-text>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Faqs from '@/views/Faqs'
export default {
  computed: {

  },
  components: {
      Faqs
  },
  name: "App",
  data() {
    return {
    };
  }
};
</script>